import React from 'react';
import { SectionLabel } from './SectionLabel';
import { StickerCard } from '../ui/StickerCard';

export function DemoBlock() {
  return (
    <section className="bg-green-700 text-white py-16 md:py-24 relative overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.05) 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      />
      <div className="relative max-w-shell mx-auto px-4 md:px-6 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <SectionLabel tone="gold">Como fica no app</SectionLabel>
          <h2 className="font-display font-bold text-h1 md:text-[36px] leading-tight mt-3">
            Visual limpo, no clima do álbum.
          </h2>
          <p className="font-body text-body text-white/85 leading-relaxed mt-5 max-w-md">
            Interface com toques rápidos pra marcar figurinha e fácil de usar, pronto para todo
            mundo do grupo usar!
          </p>
        </div>

        <div className="flex justify-center">
          <div className="relative bg-paper rounded-[28px] p-5 max-w-[300px] w-full shadow-lg border border-white/10">
            <p className="bt-eyebrow text-green-700 mb-3">BRASIL · 12/19</p>
            <div className="grid grid-cols-4 gap-2">
              {[1, 1, 2, 0, 1, 1, 0, 1, 3, 1, 0, 1].map((c, i) => (
                <StickerCard key={i} code={`BRA${i + 1}`} count={c} size="sm" />
              ))}
            </div>
            <div className="h-1.5 bg-ink-100 rounded-full overflow-hidden mt-4">
              <div
                className="h-full"
                style={{
                  width: '63%',
                  background: 'linear-gradient(90deg, #009C3B, #FFDF00)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
